import axiosInstance from "api/axiosInstance";

import type { ForceReservationRequest, ForceReservationResponse, ReservationAdminCancelRequest, ReservationAdminCancelResponse } from "api/types/admin-reservations.types";

const LESSONS_BASE = "/server/buccl_lessons/api/v1/";

export const adminReservationsService = {
  // 어드민: 강습/연습반 강제 예약
  forceReservation: (payload: ForceReservationRequest) => axiosInstance.post<ForceReservationResponse>(`${LESSONS_BASE}admin/force-reservation/`, payload),

  // 어드민: 강습 예약 강제 취소
  adminCancel: (reservationId: number, payload?: ReservationAdminCancelRequest) => axiosInstance.post<ReservationAdminCancelResponse>(`${LESSONS_BASE}reservations/${reservationId}/admin-cancel/`, payload ?? {}),
};
